<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Sites</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_SITE_WRITE']" class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add Site
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">

    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control"
             placeholder="Filter by name" style="padding: 11px;">

      <app-dropdown-select [(ngModel)]="filters.values['productId']" (onDropdownChange)="filters.onFilterChange()"
                           [multiple]="true" placeholder="Filter by brand" class="form-control">
        @for (product of products; track product.id) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['advertiserId']" (onDropdownChange)="filters.onFilterChange()"
                           [multiple]="true" placeholder="Filter by advertiser" class="form-control">
        @for (advertiser of advertisers; track advertiser.id) {
          <app-dropdown-select-option [value]="advertiser.id">{{ advertiser.companyName }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['lang']" (onDropdownChange)="filters.onFilterChange()"
                           [multiple]="true" placeholder="Filter by lang" class="form-control">
        @for (lang of languages; track lang.isoCode) {
          <app-dropdown-select-option [value]="lang.isoCode">{{ lang.name }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="name">Name</th>
            <th tableSorterHeader="product">Brand</th>
            <th tableSorterHeader="product.advertiser">Advertiser</th>
            <th tableSorterHeader="domain">Domain</th>
            <th tableSorterHeader="url">URL</th>
            <th>Lang</th>
            <th tableSorterHeader="enabled">Status</th>
            <th tableSorterHeader="partner">Default Partner</th>
            <th tableSorterHeader="offer">Default Offer</th>
            <th tableSorterHeader="status">Status</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (site of sites; track site) {
            <tr>
              <td>{{ site.id }}</td>
              <td>{{ site.name }}</td>
              <td>{{ site.product }}</td>
              <td>{{ site.product?.advertiser }}</td>
              <td>{{ site.domain }}</td>
              <td>{{ site.url }}</td>
              <td>
                @if (site.lang) {
                  <img [ngSrc]="langService.getFlag(site.lang)" [alt]="site.lang" class="country-flag"
                    width="24" height="24">
                }
              </td>
              <td>
                @if (site.enabled) {
                  <span class="badge bg-success">Enabled</span>
                }
                @if (!site.enabled) {
                  <span class="badge bg-danger">Disabled</span>
                }
              </td>
              <td>{{ site.partnerId }}</td>
              <td>{{ site.offerId }}</td>
              <td>
                @if (site.status === 'succeeded') {
                  <i class="bi bi-circle-fill text-success"></i>
                } @else if (site.status === 'failed') {
                  <i class="bi bi-circle-fill text-danger"></i>
                } @else {
                  <i class="bi bi-circle-fill text-dark"></i>
                }
              </td>
              <td class="text-center">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[site.id]"><i class="bi bi-pencil me-1"></i>Edit</a>
                <button *isGranted="['ROLE_API_SITE_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(site)"><i
                class="bi bi-trash"></i></button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
